/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getServiceAuth.defs.js'
export * as $defs from './getServiceAuth.defs.js'
